import { Inject, Injectable, NgZone } from '@angular/core';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { IMedicalOrder } from '@alberta/konexi-shared';
import { MedicalOrderChannel } from 'src/app/business/medical-order/contracts/medical-order-channel';
import { MedicalOrderModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';

@Injectable()
export class MedicalOrderSyncService extends SyncService<IMedicalOrder> {
  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<IMedicalOrder>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(MedicalOrderModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }
  public canSync(channel: string): boolean {
    return (
      channel === MedicalOrderChannel.CREATE ||
      channel === MedicalOrderChannel.EDIT ||
      channel === MedicalOrderChannel.DELETE
    );
  }
}
